<template>
    <div>
        <v-row class="table-title ma-1 rounded">
            <v-col cols="12" md="4">
                <p class="mb-0 table-header">Key</p>
            </v-col>
            <v-col cols="12" md="4">
                <p class="mb-0 table-header"> Value </p>
            </v-col>
            <v-col cols="12" md="2">
                <p class="mb-0 table-header"> Date </p>
            </v-col>
            <v-col cols="12" md="2">
                <p class="mb-0 table-header"> Actions </p>
            </v-col>
        </v-row>
        <br>
        <div v-if="settings.length > 0">
            <v-row class="table-row" align="center" v-for=" (setting,i) in settings " :key="setting.key">
                <v-col cols="12" md="4">
                    <v-card flat class="card dt-border">
                        <p class="mb-0 text-capitalize">{{ name(setting.key) }}</p>
                    </v-card>
                </v-col>
                <v-col class="active-field" cols="12" md="4">
                    <v-card flat class="card dt-border">
                        <p class="mb-0 text-capitalize">{{ setting.value }}</p>
                    </v-card>
                </v-col>
                <v-col class="align-center" cols="12" md="2">
                    <p class="mb-0 text-capitalize">{{ formatDate(setting.updated) }}</p>
                </v-col>
                <v-col cols="12" md="2">
                    <v-btn :disabled="!can('can_edit_system_settings')" @click="setting.editable = true" icon color="primary">
                        <v-icon>
                            mdi-database-edit-outline
                        </v-icon>
                    </v-btn>
                </v-col>
                <editsettings-modal @update="update(i, $event)" @closeModal="setting.editable = false" :dialog="setting.editable" :setting="setting"/>
            </v-row>
        </div>
    </div>
</template>

<script>
import EditsettingsModal from "../component/edit-settings.vue"
export default {
    components:{
        EditsettingsModal
    },
    props:{
        settings:{
            type: Array
        }
    },
    methods:{
        name(name){
            return name.replace(/-/g,' ')
        },
        formatDate(date){
            let d = new Date(date)
            let reModelDate = d.toLocaleString(["en-Us"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
            });
            return reModelDate;
        },
        update(index,data){
            this.settings[index]['value'] = data.value;
            this.settings[index]['updated'] = data.updated;
            this.$store.dispatch("toast", {
                message:  data.key + " " + "successfully updated",
                variant: "success",
            });
        }
    }
    
}
</script>
<style lang="scss" scoped>
@import './styles.scss'
</style>